import { defineCopy } from "@tami/core/intl";

import { SIDEBAR_COPY_EN_US } from "./en-us/sidebar.copy";
import { SIDEBAR_COPY_ES_ES } from "./es-es/sidebar.copy";

/** Textos da barra lateral. */
export const SIDEBAR_COPY_PT_BR = {
  toggle: "Mostrar ou ocultar a barra lateral",
  /** Título e descrição só para leitor de tela da barra lateral no celular. */
  mobileTitle: "Menu",
  mobileDescription: "Navegação do celular",
} as const;

export const SIDEBAR_COPY = defineCopy(SIDEBAR_COPY_PT_BR, {
  "en-US": SIDEBAR_COPY_EN_US,
  "es-ES": SIDEBAR_COPY_ES_ES,
});
